// extracted by mini-css-extract-plugin
export var buttons = "_ay-0";
export var buttonsActive = "_ay-h";
export var cancelConfirm = "_ay-1";
export var closeButton = "_ay-2";
export var column = "_ay-3";
export var container = "_ay-4";
export var detailHeader = "_ay-6";
export var detailTitle = "_ay-7";
export var detailsContent = "_ay-5";
export var header = "_ay-8";
export var headerWithClose = "_ay-9";
export var icon = "_ay-a";
export var infoIcon = "_ay-c";
export var informationContainer = "_ay-b";
export var sideDrawer = "_ay-d";
export var sideDrawerOpen = "_ay-e";
export var stickyFooter = "_ay-f";
export var typeOption = "_ay-g";